import {
    monthlyTargetCreatePost,
    monthlyTargetDeleteDel,
    monthlyTargetDetailsGet,
    monthlyTargetListGet, monthlyTargetUpdatePut
} from "../Model/MonthlyTargetModel";
import {del, get, post, put} from "../../../../GlobalModules/Utility/Http";

/**
 * Fetch monthly target list with optional filters
 * @param {Object} filters - Filter parameters for the API call
 * @returns {Promise} Processed monthly target list data
 */
export const getMonthlyTargetList = async (filters = {}) => {
    // Format filters according to the API structure in Postman collection
    const queryParams = {
        filters: {
            store_id: localStorage.getItem('store_id'),
            limit: filters.limit || 10,
            offset: filters.offset || 0,
        }
    };

    if (filters.start_date) {
        queryParams.filters.start_date = filters.start_date;
    }

    if (filters.end_date) {
        queryParams.filters.end_date = filters.end_date;
    }

    if (filters.search) {
        queryParams.filter_op = JSON.stringify({ search_attr: "substring" });
        queryParams.filters.search_attr = filters.search
    }

    if (filters.sort) {
        queryParams.filters.sort = filters.sort.map(item => ({
            colId: item.field,
            sort: item.sort
        }));
    }

    queryParams.filters = JSON.stringify(queryParams.filters);

    const response = await get(`${process.env.EXTENDED_URL}/target`, queryParams);

    return monthlyTargetListGet(response)
}

/**
 * Fetch single monthly target details by ID
 * @param {string|number} id - Monthly target ID
 * @returns {Promise} Processed monthly target details
 */
export const getMonthlyTargetDetails = async (id) => {
    const response = await get(`${process.env.EXTENDED_URL}/target/${id}`);
    return monthlyTargetDetailsGet(response);
};

/**
 * Create a new monthly target
 * @param {Object} accountData - Monthly target data to create
 * @returns {Promise} Creation response
 */
export const createMonthlyTarget = async (accountData) => {
    const response = await post(`${process.env.EXTENDED_URL}/target`, accountData);
    return monthlyTargetCreatePost(response);
};

/**
 * Delete a monthly target
 * @param {string|number} slack - Monthly target ID
 * @returns {Promise} Delete response
 */
export const deleteMonthlyTarget = async (slack) => {
    const response = await del(`${process.env.EXTENDED_URL}/target/${slack}`);
    return monthlyTargetDeleteDel(response);
};

/**
 * Update an existing monthly target
 * @param {string|number} slack - Monthly target ID
 * @param {Object} stockTransferData - Updated monthly target data
 * @returns {Promise} Update response
 */
export const updateMonthlyTarget = async (slack, stockTransferData) => {
    const response = await put(`${process.env.EXTENDED_URL}/target/${slack}`, stockTransferData);
    return monthlyTargetUpdatePut(response);
};